var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.bodyWidthVars),attrs:{"id":"app"}},[_c('el-scrollbar',[_c('div',{staticClass:"content-wrapper"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }